import { render } from "./Show.vue?vue&type=template&id=4081f1fa"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
script.render = render

export default script